import { useEffect, useState } from "react";
import useApi from "./useApi";
import generosDefault from "../utils/generos";

// Lista de géneros musicales administrable desde el panel admin.
// Arranca con la lista estática histórica para no bloquear la UI y se
// reemplaza con la del backend cuando responde; si la API falla, la
// estática queda como fallback.
const useGeneros = () => {
  const { loadApi } = useApi();
  const [generos, setGeneros] = useState(generosDefault);

  useEffect(() => {
    loadApi("general/generos", false, "get")
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0)
          setGeneros(res.data);
      })
      .catch(() => {});
  }, []);

  return generos;
};

export default useGeneros;
